var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.options),function(option){return _c('lck-badge',{key:option.value,attrs:{"backgroundColor":option.backgroundColor,"color":option.color,"label":option.label}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }